import axios from "axios";

const DEFAULT_API_URL = "https://api-dev.virgilipsas.com";
const AUTH_STORAGE_KEY = "virgil_budget_portal_auth";
const USER_STORAGE_KEY = "virgil_budget_portal_user";

const handleUnauthorized = () => {
  window.localStorage.removeItem(AUTH_STORAGE_KEY);
  window.localStorage.removeItem(USER_STORAGE_KEY);

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

const isAuthFailure = (error) => {
  const status = error?.response?.status;
  const responseStatus = error?.response?.data?.status;

  return status === 302 || responseStatus === 302;
};

export const createApiClient = (token = "") => {
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL || DEFAULT_API_URL,
    headers: token
      ? {
        Authorization: `Bearer ${token}`,
      }
      : {},
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isAuthFailure(error)) {
        handleUnauthorized();
      }

      return Promise.reject(error);
    },
  );

  return client;
};
